import { MESSAGING } from 'core/datasets/action';
import { messagingActions } from 'messaging/redux/messagingActions';
import { AddChannelKeyAction } from 'messaging/types/redux/messagingActions';
import { call, fork, put } from 'redux-saga/effects';
import { onItemChangedWatcher } from '../../../firebase/saga/workers/onItemChangedWatcher';
import { getChannelLastActivity, getChannelRef, getDisplayName, getFirebaseUser } from './firebaseUtils';

export function* fetchChannelDataByKey(action: AddChannelKeyAction): Generator {
    const { payload } = action;
    const dbKey = `channels/${payload}/meta`;

    const channelData = yield call(getChannelRef, payload);

    if (!channelData) {
        return;
    }

    const firebaseUser = yield call(getFirebaseUser);
    const displayName = yield call(getDisplayName);
    const lastActivity = yield call(getChannelLastActivity, payload, (firebaseUser as any).uid);

    yield put(
        messagingActions.addChannel({
            id: payload,
            name: String(displayName || ''),
            messages: [],
            lastMessage: (channelData as any)?.last_message ?? null,
            lastMessageTimestamp: (channelData as any)?.last_updated ?? null,
            hasUnread: false,
            viewed: lastActivity as number,
        }),
    );
    yield fork(
        onItemChangedWatcher,
        dbKey,
        MESSAGING.CHANGE_CHANNEL_FIELD,
        (data) => {
            const fieldMatch: { [key: string]: string } = {
                last_message: 'lastMessage',
                last_updated: 'lastMessageTimestamp',
            };
            if (data.key && fieldMatch[data.key])
                return { channelId: payload, field: fieldMatch[data.key], value: data.val() };
            return null;
        },
        true,
    );
}
